export default "__VITE_ASSET__vYKDvvCp__"